/* eslint-disable i18n/no-russian-character */
import { UiCartInformerAdditional } from '@/fo/ui/cart/informer/additional';

export function BonusSbp() {
  return (
    <UiCartInformerAdditional
      image="/media/cart/informer-sbp.png"
      title={
        <p>
          <span className="font-semibold">Скидка 3%</span> при оплате банковской
          картой на сайте или СБП
        </p>
      }
      href="/test"
    />
  );
}
